<div  [matTooltip]="tooltip" class="wrapper">
  <span class="badge" [class]="status">{{ value }}</span>
</div>
